G.BoardCandy = G.BoardCandy || {};

G.BoardCandy.CandyType = function() {
  this._collected = false;

  this.signals = {
    removeCandy: new Phaser.Signal(),
    changeCandyTexture: new Phaser.Signal(),
  };
};

G.BoardCandy.CandyType.prototype = {
  init: function(candy, config) {
    this.candy = candy;
    if (config.texture) {
      this.signals.changeCandyTexture.dispatch(config.texture);
    }
    this.candyType = config.candyType;
    this.matchable = G.Utils.defined(config.matchable, true);
    this.canBeChangedIntoSpecialType = G.Utils.defined(config.canHaveSpecialType, true);
    this.tags = G.Utils.defined(config.tags, []);
    this.editorSymbol = G.Utils.defined(config.editorSymbol, "");
  },


  isAlreadyCollected: function() {
    return this._collected;
  },

  markAsCollected: function() {
    this._collected = true;
  },

  isBlockingMove: function() {
    return false;
  },

  isMatchable: function() {
    return this.matchable;
  },

  onMove: function(otherCandy) {
    return true;
  },

  onMatch: function() {
    return true;
  },

  onBooster: function() {
    
  },

  onHit: function() {
    return false;
  },

  canHaveSpecialType: function() {
    return this.canBeChangedIntoSpecialType;
  },

  getEditorSymbol: function() {
    return this.editorSymbol;
  },

  collect: function() {

  },

  export: function() {
    return this.editorSymbol;
  },

  hasTag: function(tag) {
    return this.tags.indexOf(tag) !== -1;
  },
};